// Parent Mode label map. One place that decides the wording for every screen so
// teacher vs. parent copy stays consistent. Layout never changes — only labels,
// copy, and questions. Teacher strings are the exact originals.
import { User, isParent } from './storage';

export interface RoleLabels {
  isParent: boolean;
  // Navigation / actions
  talk: string;              // "Talk About a Student" / "Talk About My Child"
  students: string;          // "My Students" / "My Kids"
  studentsNav: string;       // NavBar tab: "Students" / "My Kids"
  urgencyTitle: string;      // Dashboard urgency button title
  urgencySub: string;        // Dashboard urgency button subtitle
  communication: string;     // "Communication Helper" / "Talking to the Teacher"
  burnout: string;           // "Burnout Tracker" / "Parent Check-In"
  friday: string;            // "Friday Debrief" / "Weekend Debrief"
  // Subject vocabulary
  subject: string;           // "student" / "child"
  subjectCap: string;        // "Student" / "Child"
  subjectPlural: string;     // "students" / "kids"
  // Identify screen
  identifyLabel: string;     // "Student initials" / "Child's first name or nickname"
  identifyPlaceholder: string;
  gradeLabel: string;        // "Grade" / "Age or grade"
  // Talk / profile tabs that only make sense in a classroom
  mtssTab: string;           // "MTSS" / "What to ask the school for"
  referralTab: string;       // "Referral" / "When to get outside help"
}

export function roleLabels(user: User | null | undefined): RoleLabels {
  const parent = isParent(user);
  if (parent) {
    return {
      isParent: true,
      talk: 'Talk About My Child',
      students: 'My Kids',
      studentsNav: 'My Kids',
      urgencyTitle: '🚨 Something Is Happening RIGHT NOW',
      urgencySub: 'One calm thing to do — and what to say — in seconds',
      communication: 'Talking to the Teacher',
      burnout: 'Parent Check-In',
      friday: 'Weekend Debrief',
      subject: 'child',
      subjectCap: 'Child',
      subjectPlural: 'kids',
      identifyLabel: "Your child's first name or nickname",
      identifyPlaceholder: 'First name or nickname',
      gradeLabel: 'Age or grade',
      mtssTab: 'What to ask',
      referralTab: 'Outside help',
    };
  }
  return {
    isParent: false,
    talk: 'Talk About a Student',
    students: 'My Students',
    studentsNav: 'Students',
    urgencyTitle: '🚨 I Need Help RIGHT NOW',
    urgencySub: 'Quick strategy or de-escalation script — in seconds',
    communication: 'Communication Helper',
    burnout: 'Burnout Tracker',
    friday: 'Friday Debrief',
    subject: 'student',
    subjectCap: 'Student',
    subjectPlural: 'students',
    identifyLabel: 'Student initials',
    identifyPlaceholder: 'e.g. J.T.',
    gradeLabel: 'Grade',
    mtssTab: 'MTSS',
    referralTab: 'Referral',
  };
}
